import { Effect } from '@babylonjs/core/Materials/effect';

/**
 * Info Hotspot Shader
 * A sleek, modern shader with Fresnel glow and gentle pulsing
 */
/**
 * Info Hotspot Shader
 * A sleek, modern shader with Fresnel glow and gentle pulsing
 */
Effect.ShadersStore["infoHotspotVertexShader"] = `
precision highp float;

// Attributes
attribute vec3 position;
attribute vec3 normal;
attribute vec2 uv;

// Uniforms
uniform mat4 worldViewProjection;
uniform mat4 world;
uniform float time;
uniform float hoverStrength;

// Varying
varying vec2 vUV;
varying vec3 vPositionW;

void main(void) {
    vec3 p = position;
    
    // Subtle breathing animation (scale)
    // Since it's a plane, we can just scale the position relative to center
    float breath = 1.0 + sin(time * 2.0) * 0.02;
    p *= breath;
    
    // Expand on hover
    p *= (1.0 + hoverStrength * 0.1);

    gl_Position = worldViewProjection * vec4(p, 1.0);
    
    vUV = uv;
    vPositionW = vec3(world * vec4(position, 1.0));
}
`;

Effect.ShadersStore["infoHotspotBackgroundFragmentShader"] = `
precision highp float;

// Varying
varying vec2 vUV;
varying vec3 vPositionW;

// Uniforms
uniform vec3 cameraPosition;
uniform vec3 color;
uniform float time;
uniform float hoverStrength;

void main(void) {
    vec2 uv = vUV - 0.5;
    float dist = length(uv);

    // === STRICT CIRCULAR MASK ===
    // Sharp cutoff for clean circle edge
    float circleMask = 1.0 - smoothstep(0.44, 0.48, dist);

    if (circleMask < 0.01) {
        discard;
    }

    // === COLOR PALETTE FROM USER COLOR ===
    vec3 colorCore = color * 1.4;           // Bright center
    vec3 colorMid = color * 1.1;            // Main color
    vec3 colorEdge = color * 0.7;           // Darker edge
    vec3 colorGlow = mix(color, vec3(1.0), 0.3); // Light glow

    // === SOLID CIRCULAR GRADIENT ===
    // Smooth radial gradient from center to edge
    float centerGlow = smoothstep(0.45, 0.0, dist);      // Bright center falloff
    float midLayer = smoothstep(0.48, 0.15, dist);       // Mid fill
    float solidBase = smoothstep(0.5, 0.3, dist) * 0.8;  // Base opacity

    // === SUBTLE PULSE ===
    float pulse = sin(time * 1.8) * 0.5 + 0.5;
    float pulseAmount = 0.08 + pulse * 0.12;

    // === INNER HIGHLIGHT RING ===
    float innerRingDist = abs(dist - 0.25);
    float innerRing = smoothstep(0.08, 0.0, innerRingDist) * 0.15;

    // === EDGE RING (OUTLINE) ===
    float edgeRingDist = abs(dist - 0.44);
    float edgeRing = smoothstep(0.04, 0.0, edgeRingDist) * 0.6;

    // === HOVER EFFECTS ===
    float hoverGlow = 0.0;
    float hoverEdge = 0.0;
    if (hoverStrength > 0.0) {
        // Brighten entire orb
        hoverGlow = hoverStrength * 0.35;
        // Enhance edge ring on hover
        hoverEdge = hoverStrength * smoothstep(0.06, 0.0, edgeRingDist) * 0.5;
        // Faster pulse on hover
        pulseAmount += hoverStrength * 0.15 * (sin(time * 3.5) * 0.5 + 0.5);
    }

    // === COMPOSITE COLOR ===
    // Layer colors from edge to center
    vec3 baseColor = colorEdge;
    baseColor = mix(baseColor, colorMid, midLayer);
    baseColor = mix(baseColor, colorCore, centerGlow * 0.7);

    // Add pulse brightness
    baseColor *= (1.0 + pulseAmount);

    // Add inner ring subtle highlight
    baseColor += colorGlow * innerRing;

    // Add edge ring (white-tinted)
    vec3 ringColor = mix(color, vec3(1.0), 0.5);
    baseColor += ringColor * (edgeRing + hoverEdge);

    // Add hover glow
    baseColor += color * hoverGlow;

    // === FINAL ALPHA ===
    // Solid in center, clean edge
    float alpha = solidBase + centerGlow * 0.3 + edgeRing * 0.4;
    alpha += hoverStrength * 0.25;
    alpha *= circleMask;
    alpha = clamp(alpha, 0.0, 1.0);

    gl_FragColor = vec4(baseColor, alpha);
}
`;

/**
 * Info Hotspot Icon Shader
 * Just the 'i' icon, clean and white
 * NOW INCLUDES OUTLINE
 */
Effect.ShadersStore["infoHotspotIconFragmentShader"] = `
precision highp float;

varying vec2 vUV;

// Uniforms
uniform vec3 color;
uniform float time;
uniform float hoverStrength;

void main(void) {
    vec2 uv = vUV - 0.5;
    float dist = length(uv);
    
    // 1. The 'i' Icon
    // Scale coordinates for icon size (0.4 scale factor)
    vec2 centeredUV = uv * 0.4; 
    
    // Dot
    float dotDist = length(centeredUV - vec2(0.0, 0.06));
    float dotShape = 1.0 - smoothstep(0.012, 0.016, dotDist);
    
    // Body
    vec2 bodySize = vec2(0.012, 0.05);
    vec2 bodyPos = centeredUV - vec2(0.0, -0.04);
    vec2 d = abs(bodyPos) - bodySize;
    float bodyDist = length(max(d, 0.0)) + min(max(d.x, d.y), 0.0);
    float bodyShape = 1.0 - smoothstep(0.0, 0.004, bodyDist);
    
    float iconAlpha = max(dotShape, bodyShape);
    
    // 2. Circular Outline
    // Ring around the edge (0.5 radius)
    float ring = smoothstep(0.45, 0.48, dist) * (1.0 - smoothstep(0.48, 0.49, dist));
    ring *= 2.0;
    
    // Hover boost for ring
    if (hoverStrength > 0.0) {
        // Ring boost masked to ring area
        float ringMask = smoothstep(0.45, 0.48, dist) * (1.0 - smoothstep(0.48, 0.49, dist));
        ring += hoverStrength * ringMask;
    }
    
    // 3. Composite
    vec3 finalColor = vec3(0.0);
    
    // Icon (White)
    finalColor += vec3(1.0) * iconAlpha;
    
    // Outline (White/Color tint)
    vec3 ringColor = mix(color, vec3(1.0), 0.7);
    finalColor += ringColor * ring;
    
    // Alpha
    float alpha = iconAlpha + ring;
    alpha = clamp(alpha, 0.0, 1.0);
    
    gl_FragColor = vec4(finalColor, alpha);
}
`;

/**
 * Audio Hotspot Shader
 * Audio-reactive waveform with Play/Pause icon
 */
Effect.ShadersStore["audioHotspotVertexShader"] = `
precision highp float;

// Attributes
attribute vec3 position;
attribute vec3 normal;
attribute vec2 uv;

// Uniforms
uniform mat4 worldViewProjection;
uniform mat4 world;
uniform float time;
uniform float hoverStrength;
uniform float audioLevel;

// Varying
varying vec2 vUV;
varying vec3 vPositionW;

void main(void) {
    vec3 p = position;
    
    // Pulse to the beat
    float beat = 1.0 + audioLevel * 0.2;
    p *= beat;
    
    // Expand on hover
    p *= (1.0 + hoverStrength * 0.1);

    gl_Position = worldViewProjection * vec4(p, 1.0);
    
    vUV = uv;
    vPositionW = vec3(world * vec4(position, 1.0));
}
`;

Effect.ShadersStore["audioHotspotFragmentShader"] = `
precision highp float;

// Varying
varying vec2 vUV;
varying vec3 vPositionW;

// Uniforms
uniform vec3 cameraPosition;
uniform vec3 color;
uniform float time;
uniform float hoverStrength;
uniform float audioLevel;
uniform float isPlaying; // 0.0 = Paused, 1.0 = Playing

// Smooth rounded rectangle SDF
float roundedBox(vec2 p, vec2 size, float radius) {
    vec2 d = abs(p) - size + radius;
    return length(max(d, 0.0)) + min(max(d.x, d.y), 0.0) - radius;
}

void main(void) {
    vec2 uv = vUV - 0.5;
    float dist = length(uv);

    // 1. Background
    vec3 finalColor = vec3(0.0);
    float alpha = 0.0;

    // Circular mask with soft edge
    float circleMask = 1.0 - smoothstep(0.38, 0.48, dist);

    // Solid color background disc
    float solidBg = smoothstep(0.48, 0.35, dist) * 0.7;
    finalColor += color * solidBg;
    alpha += solidBg;

    // Subtle outer glow
    float outerGlow = smoothstep(0.5, 0.3, dist) * 0.3;
    finalColor += color * outerGlow * 0.5;

    // Animated Waveforms (Rings) - only when playing
    float activity = isPlaying;

    if (activity > 0.0) {
        for (float i = 0.0; i < 3.0; i++) {
            float t = time * 1.5 - i * 0.4;
            float r = fract(t);
            float ringDist = abs(dist - r * 0.45);
            float ring = 1.0 - smoothstep(0.0, 0.03 + audioLevel * 0.05, ringDist);

            float fade = (1.0 - r) * (1.0 - r);

            finalColor += color * ring * fade * activity * 0.4;
            alpha += ring * fade * activity * 0.3;
        }
    }

    // 2. Play / Pause Icon - Properly Centered with Smooth Edges
    // Icon is 2x larger (smaller UV multiplier = bigger icon)
    float iconAlpha = 0.0;
    vec2 iconUV = uv * 2.5; // Scale for icon (was 5.0, now 2.5 for 2x size)
    float smoothing = 0.04; // Anti-aliasing width (halved for larger icon)

    if (isPlaying < 0.5) {
        // PLAY TRIANGLE - Equilateral, centered at origin
        // Triangle with centroid at (0,0), pointing right
        // Vertices: left-top (-0.15, 0.25), left-bottom (-0.15, -0.25), right (0.30, 0.0)
        // Centroid: ((-0.15 - 0.15 + 0.30)/3, 0) = (0, 0) ✓

        vec2 p = iconUV;

        // Three edge tests for the triangle (using signed distance)
        // Right edge (vertical line from left vertices): x > -0.15
        // Top-right edge: from (-0.15, 0.25) to (0.30, 0)
        // Bottom-right edge: from (-0.15, -0.25) to (0.30, 0)

        float leftEdge = -p.x - 0.15;  // Negative inside

        // Top edge: line from (-0.15, 0.25) to (0.30, 0.0)
        // Normal direction pointing inward (downward): (0.25, 0.45) normalized
        vec2 topNormal = normalize(vec2(0.25, 0.45));
        float topEdge = dot(p - vec2(-0.15, 0.25), topNormal);

        // Bottom edge: line from (-0.15, -0.25) to (0.30, 0.0)
        // Normal direction pointing inward (upward): (-0.25, 0.45) normalized
        vec2 bottomNormal = normalize(vec2(0.25, -0.45));
        float bottomEdge = dot(p - vec2(-0.15, -0.25), bottomNormal);

        // Combine with smooth edges
        float triDist = max(max(leftEdge, topEdge), bottomEdge);
        iconAlpha = 1.0 - smoothstep(-smoothing, smoothing, triDist);

    } else {
        // PAUSE BARS - Two rounded rectangles, centered
        // Bar dimensions: width 0.12, height 0.5, gap 0.16 between them
        // Bar 1 center: (-0.14, 0), Bar 2 center: (0.14, 0)

        vec2 barSize = vec2(0.12, 0.5);
        float cornerRadius = 0.06;

        float bar1 = roundedBox(iconUV - vec2(-0.14, 0.0), barSize * 0.5, cornerRadius);
        float bar2 = roundedBox(iconUV - vec2(0.14, 0.0), barSize * 0.5, cornerRadius);

        float barsDist = min(bar1, bar2);
        iconAlpha = 1.0 - smoothstep(-smoothing, smoothing, barsDist);
    }

    // Icon Color (White) with slight shadow for depth
    vec3 iconColor = vec3(1.0);
    finalColor = mix(finalColor, iconColor, iconAlpha * 0.95);
    alpha = max(alpha, iconAlpha);

    // Apply circle mask
    alpha *= circleMask;
    finalColor *= circleMask;

    // Hover Highlight - subtle brightening
    if (hoverStrength > 0.0) {
        finalColor += color * 0.3 * hoverStrength * circleMask;
        alpha = min(1.0, alpha + hoverStrength * 0.15 * circleMask);
    }

    gl_FragColor = vec4(finalColor, alpha);
}
`;
